import { ColProps, colTypeOptions, FetchProps, FilterProps, filterTypeOptions } from "../../components/table/tableTypes";
import { exportToCsv } from "../../utils/exportToCsv";
import {dateDaysAgo, formatDate, shortFormatDate, shortFormatDateNoTime} from "../../utils/friendlyDate";
import Table from "../../components/table/Table";
import { getOrders } from "../../api/getOrders";
import {Tooltip} from "antd";
import {useState} from "react";
import CheckoutPanel from "../../components/checkoutPanel/CheckoutPanel";

const OrdersTable = () => {
    const [checkoutId, setCheckoutId] = useState<number | undefined>(undefined);

    const onRowClick = (row: any) => {
        setCheckoutId(row.checkout_id);
    }

    const fetch = async ({ filters, sortingBy, sortingDirection, limit, offset, selectedDomain, isCsvCall }: FetchProps) => {
        const response = await getOrders(selectedDomain, filters);
        if(isCsvCall) {
            exportToCsv(response.data.report, `Vuelve Orders Log - ${selectedDomain} - ${formatDate(new Date())}`);
        } else {
            return selectedDomain ? response : [];
        }
    }

    const cols: ColProps[] = [
        { key: 'days', name: 'Date', type: colTypeOptions.date, paddingLeft: 0, render: (value: Date) => <Tooltip title={(shortFormatDate(new Date(value)).toString())}>{shortFormatDateNoTime(new Date(value))}</Tooltip> },
        { key: 'order_id', name: 'Order ID', type: colTypeOptions.text },
        { key: 'checkout_id', name: 'Checkout ID', type: colTypeOptions.text },
        { key: 'client_id', name: 'Client', type: colTypeOptions.text, render: (value: number, row: any) => <Tooltip title={`ID: ${value}`}><div className="capitalize">{row.full_name}</div></Tooltip> },
        { key: 'price_usd', name: 'Price', type: colTypeOptions.usd },
        { key: 'messages_sent', name: 'Messages Sent', type: colTypeOptions.number },

    ];

    const filters: FilterProps[] = [
        { filterKey: 'days', name: 'date range', type: filterTypeOptions.date, min: dateDaysAgo(120), max: new Date(), from: dateDaysAgo(7), to: new Date() },
        { filterKey: 'checkoutId', name: 'Checkout ID', type: filterTypeOptions.text },
        { filterKey: 'clientId', name: 'Client ID', type: filterTypeOptions.text },
        { filterKey: 'orderId', name: 'Order ID', type: filterTypeOptions.text }
    ];

    return (
        <div className="reports-container">
            <Table onRowClick={onRowClick} title="Orders Log" fetch={fetch} cols={cols} filters={filters} showSearch={false} doneLoadingDependencies={true} />
            <CheckoutPanel checkoutId={checkoutId} onClose={() => setCheckoutId(undefined)} />
        </div>
    );
}

export default OrdersTable;